// [목적] 비인증 전용 라우트 가드 — 인증 상태면 / 또는 /onboarding 으로 redirect
// [이유] fe-be-wire-up Wave 1 WC-FE-AUTH-06 — Login/Onboarding 페이지 보호.
//         authenticated + isOnboarded → '/' redirect.
//         authenticated + !isOnboarded → '/onboarding' redirect (단, 현재 경로가 /onboarding 이면 통과).
//         guest/loading → children 렌더 (Login 페이지 표시).
// [사이드 이팩트] loading 중에도 children 노출 — 무한 루프 방지 (OAuthCallbackPage 가 loading 상태에서 안착).
// [수정 시 고려사항] Onboarding 페이지에 적용 시 !isOnboarded 조건으로 authenticated 사용자도 통과.

import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../providers/AuthProvider.js';

interface GuestOnlyRouteProps {
  children: ReactNode;
}

/**
 * [목적] 비인증 전용 라우트 래퍼
 * [이유] WC-FE-AUTH-06: authenticated+onboarded → '/' / authenticated+!onboarded → '/onboarding' (self 통과)
 * [사이드 이팩트] loading 및 guest 상태에서는 children 그대로 렌더
 * [수정 시 고려사항] /onboarding 경로 변경 시 ONBOARDING_PATH 상수 수정
 */
export function GuestOnlyRoute({ children }: GuestOnlyRouteProps): JSX.Element {
  const { status, isOnboarded } = useAuthContext();
  const location = useLocation();

  // loading/guest — 통과 (Login 페이지 표시)
  if (status !== 'authenticated') {
    return <>{children}</>;
  }

  // authenticated + onboarded → 홈으로
  if (isOnboarded) {
    return <Navigate to="/" replace />;
  }

  // authenticated + !onboarded
  // 현재 경로가 /onboarding 이면 통과 (무한루프 방지)
  if (location.pathname === '/onboarding') {
    return <>{children}</>;
  }

  // 그 외 → /onboarding 으로
  return <Navigate to="/onboarding" replace />;
}
